import { secondsToISO } from './seconds-to-iso';

import type { Track } from '@/types/tracks';
import type { MusicRecording } from 'schema-dts';

export const getTrackSchema = (
  tracks: Track[] | undefined
): MusicRecording[] => {
  if (!tracks) {
    return [];
  }

  return tracks.map<MusicRecording>((track) => {
    const duration = secondsToISO(track.track_version[0].version_length);

    // Only generate URL if both artist slug and track slug are present
    let trackUrl: string | undefined;
    if (track.artist?.slug && track.slug) {
      const baseUrl =
        process.env.NEXT_PUBLIC_FE_BASE_URL || 'https://uppbeat.io/';
      // Ensure proper URL construction by using URL constructor
      trackUrl = new URL(`track/${track.artist.slug}/${track.slug}`, baseUrl)
        .href;
    }

    return {
      '@type': 'MusicRecording',
      name: track.name,
      byArtist: {
        '@type': 'MusicGroup',
        name: track.artist?.name,
      },
      url: trackUrl,
      duration,
    };
  });
};
